import React from 'react';
import classNames from 'classnames';

import css from './IconEye.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconEye = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#2F3457"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M.833 10S4.166 3.333 10 3.333 19.166 10 19.166 10 15.833 16.666 10 16.666.833 10 .833 10"
      ></path>
      <path
        stroke="#2F3457"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
      ></path>
    </svg>
  );
};

export default IconEye;
